import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Address } from 'src/app/models/Address';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressInputModalComponent } from '../address-input-modal/address-input-modal.component';
import * as _ from 'lodash';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';
import { AddressService } from 'src/app/services/address.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-address-input',
  templateUrl: './address-input.component.html',
  styleUrls: ['./address-input.component.less']
})
export class AddressInputComponent implements OnInit{
  @Input() addresses : Address[];
  @Input() clientId : number;
  @Input() locationId : number;
  @Input() model : any;
  showActionButtons : boolean = true;

  constructor(public clients : ClientService, 
    private modalService: NgbModal, 
    public auth : AuthService, 
    private addService : AddressService,
    private toast : ToastrService) { }

  ngOnInit() {
    
  }

  editAddress(addy : Address) {
    const modalRef = this.modalService.open(AddressInputModalComponent, { centered: true, size: 'lg' })
    modalRef.componentInstance.name = 'AddressInputModalComponent';
    modalRef.componentInstance.address = addy;
    modalRef.componentInstance.model = this.model;
    modalRef.componentInstance.clientId = this.clientId;
    modalRef.componentInstance.locationId = this.locationId;
    modalRef.componentInstance.AddressSaved.subscribe((evt: Address) => { this.addresses.push(evt);})
  }
 
  addAddress() {
    let newAddy = new Address();
    newAddy.id = 0;
    if(this.locationId > 0) newAddy.clientLocationId = this.locationId;
    if(this.clientId > 0) newAddy.clientId = this.clientId;
    // this.addresses.push(newAddy);
    this.editAddress(newAddy);
  }

  removeAddress(addy : Address) {
    //if the address id is 0, then it hasn't been saved, can be spliced from the list
    if(addy.id == 0) {
      this.addresses.splice(this.addresses.indexOf(addy), 1);
    } else {
      //we need to create an OUP 
      if(this.locationId > 0) {
        addy.clientLocationId = this.locationId;
      }
      else if(this.clientId > 0) {
        addy.clientId = this.clientId;
      }

      this.addService.RemoveAddress(addy).subscribe((res : boolean) => {
        if(res) {
          this.toast.success('Successfully removed address!');
          this.addresses.splice(this.addresses.indexOf(addy), 1);
        }
        else {
          this.toast.error('Error removing address!', '', { closeButton: true, disableTimeOut: true });
        }
      })
    }
  }

}
